/* src/app/modules_v2/investment/real-state-investment/components/real-state-investment-form-dialog/real-state-investment-form-dialog.component.scss */
.rf-header-text {
  min-width: 0;
  padding-right: 32px;
}
.rf-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(260px, 1fr);
  gap: 20px;
  align-items: start;
}
.rf-main,
.rf-side {
  min-width: 0;
}
.rf-section + .rf-section {
  margin-top: 8px;
}
.rf-grid-3,
.rf-grid-4 {
  display: grid;
  gap: 0 16px;
}
.rf-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.rf-grid-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.rf-provider {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.rf-provider__field {
  flex: 1;
  min-width: 0;
}
.rf-provider__btn.cf-btn.mat-mdc-button-base {
  margin-top: 4px;
  flex-shrink: 0;
}
.rf-hint {
  margin: -8px 0 8px;
  font-size: 12px;
  color: #6b7280;
}
.rf-toggle {
  display: block;
  margin: 0 0 12px;
}
.rf-totals {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 8px;
}
.rf-totals__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 12px;
  background: #f4f6f8;
  border-radius: 8px;
}
.rf-totals__item--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.rf-totals__label {
  font-size: 11px;
  color: #6b7280;
}
.rf-totals__value {
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.rf-file-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.rf-file-input {
  display: none;
}
.rf-btn--danger.mat-mdc-button-base {
  color: #dc2626 !important;
}
.rf-file-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 180px;
  padding: 16px;
  border: 1px dashed #e5e7eb;
  border-radius: 10px;
  color: #6b7280;
  font-size: 13px;
  text-align: center;
}
.rf-file-empty mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #cbd5e1;
}
.rf-file-preview {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #f8fafc;
}
.rf-file-preview img {
  display: block;
  max-width: 100%;
  max-height: 460px;
  margin: 0 auto;
  object-fit: contain;
}
.rf-file-preview iframe {
  display: block;
  width: 100%;
  height: 460px;
  border: 0;
}
.rf-load-error {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  font-size: 13px;
  color: #b91c1c;
}
.rf-load-error mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.rf-save-error {
  margin: 8px 0 0;
}
@media (max-width: 900px) {
  .rf-layout {
    grid-template-columns: 1fr;
  }
  .rf-grid-4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .rf-grid-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 560px) {
  .rf-grid-3,
  .rf-grid-4,
  .rf-totals {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=real-state-investment-form-dialog.component.css.map */
